export const LogoMark = ({ size = 36 }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Jump">
    <circle cx="50" cy="50" r="48" fill="#E30613" />
    <circle cx="50" cy="50" r="19" fill="#ffffff" />
    <circle cx="50" cy="50" r="3" fill="#E30613" />
  </svg>
);

export const Wordmark = ({ className = "", style = {} }) => (
  <span className={className} style={{ fontFamily: "Chivo", fontWeight: 600, letterSpacing: "-0.01em", ...style }}>
    Jump<span style={{ color: "#E30613" }}>SEO</span>
  </span>
);

export const Logo = ({ size = 36, showWord = true }) => (
  <div className="flex items-center gap-3">
    <LogoMark size={size} />
    {showWord && <Wordmark className="text-lg text-white" />}
  </div>
);
